<!-- Freeze List Tab -->
@if (showGridHeader) {
  <div class="flex align-items-center justify-content-between cursor-pointer" pStyleClass="@next"
    enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout"
    [hideOnOutsideClick]="true"
    [attr.data-testid]="'freeze-list-header'">
    <div class="flex align-items-center justify-content-center">
      <div class="h-2rem w-2rem bg-primary text-white border-round flex align-items-center justify-content-center">
        <i class="fa fa-snowflake" [attr.data-testid]="'freeze-list-icon'"></i>
      </div>
      <div class="ml-3">
        <h4 class="text-base mb-0 line-height-1 font-bold" [attr.data-testid]="'freeze-list-title'">
          {{ 'FREEZE.FREEZE_LIST.TITLE' | translate }}
        </h4>
        @if (!loading && (freezeData$ | async)) {
          <p class="mb-0 text-xs text-600" [attr.data-testid]="'freeze-list-count'">
            {{(freezeData$ | async)?.length | number}} {{ 'FREEZE.FREEZE_LIST.ITEMS_COUNT' | translate }}
          </p>
        }
        @if (loading) {
          <p-skeleton width="7rem" height="0.9rem" styleClass="mt-1" [attr.data-testid]="'freeze-list-skeleton'" />
        }
      </div>
    </div>
    <i class="fa fa-circle-chevron-down text-primary" [attr.data-testid]="'freeze-list-chevron'"></i>
  </div>
}

<div [ngClass]="showGridHeader ? 'hidden mt-2':''" [attr.data-testid]="'freeze-list-content'">

  <!-- Content -->
  <app-data-grid [columnData]="freezeData$" [columns]="freezeTableColumns$" [selectable]="selectAllFreezes"
    (emitValue)="handleEvent($event)" (emitSelectValue)="handleSelectAll($event)" tableClasses="shadow-2 p-0 my-3"
    [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'" (onAction)="onActionEvent($event)"
    [EmptyState]="emptyStateComponent$" [paginator]="false" [gridName]="'freeze-list'" />
  <!-- Content -->

</div>
<!-- Freeze List Tab -->

<!-- Old Flow - Freeze Edit Modal (using freeze-edit component) -->
@if (!freezeV2Flow && (editFreeze$ | async); as visible) {
  <freeze-edit 
    [visible]="visible" 
    [freeze]="selectedEditFreeze$"
    (hidePopup)="HideEditFreeze($event)" 
    aria-label="edit freeze dialog" 
    data-testid="edit-freeze-dialog" />
}

<!-- New Flow (V2) - Freeze Reschedule Modal (using enhanced-freeze-sidebar) -->
@if (freezeV2Flow && (rescheduleFreeze$ | async); as visible) {
  <enhanced-freeze-sidebar 
    [visible]="visible"
    [client]="(localClient$ | async)!"
    [subscription]="(rescheduleSubscription$ | async)!"
    [tenantId]="tenantId()"
    [mode]="'reschedule'"
    [freezeToReschedule]="selectedRescheduleFreeze$.value!"
    (onCloseSideBar)="HideRescheduleFreeze($event)"
    aria-label="reschedule freeze sidebar" 
    data-testid="reschedule-freeze-sidebar" />
}

<!-- Freeze Cancel Modal -->
@if (!freezeV2Flow && (cancelFreeze$ | async); as visible) {
  <freeze-cancel [visible]="visible"  [freezeId]="selectedCancelFreeze?.freeze_id" [clientId]="selectedCancelFreeze?.client_id"
    [subscriptionId]="selectedCancelFreeze?.client_subscription.id" [tenantId]="tenantId()" [freeze]="selectedCancelFreeze$"
    (hidePopup)="HideCancelFreeze($event)" aria-label="cancel freeze dialog" data-testid="cancel-freeze-dialog" />
}

<!-- Freeze Stop Modal -->
@if (!freezeV2Flow && (stopFreeze$ | async); as visible) {
  <freeze-stop [visible]="visible" [freezeId]="selectedStopFreeze?.freeze_id" [clientId]="selectedStopFreeze?.client_id"
    [subscriptionId]="selectedStopFreeze?.client_subscription.id" [tenantId]="tenantId()" [freeze]="selectedStopFreeze$"
    (hidePopup)="HideStopFreeze($event)" aria-label="stop freeze dialog" data-testid="stop-freeze-dialog" />
}

<!-- New Flow (V2) - Freeze Cancel Sidebar -->
@if (freezeV2Flow && (cancelFreezeV2$ | async); as visible) {
  <enhanced-freeze-sidebar 
    [visible]="visible"
    [client]="(localClient$ | async)!"
    [subscription]="(cancelSubscription$ | async)!"
    [tenantId]="tenantId()"
    [mode]="'cancel'"
    [freezeToReschedule]="selectedCancelFreezeV2$.value!"
    (onCloseSideBar)="HideCancelFreeze($event)"
    aria-label="cancel freeze sidebar" 
    data-testid="cancel-freeze-sidebar" />
}

<!-- New Flow (V2) - Freeze Stop Sidebar -->
@if (freezeV2Flow && (stopFreezeV2$ | async); as visible) {
  <enhanced-freeze-sidebar 
    [visible]="visible"
    [client]="(localClient$ | async)!"
    [subscription]="(stopSubscription$ | async)!"
    [tenantId]="tenantId()"
    [mode]="'stop'"
    [freezeToReschedule]="selectedStopFreezeV2$.value!"
    (onCloseSideBar)="HideStopFreeze($event)"
    aria-label="stop freeze sidebar" 
    data-testid="stop-freeze-sidebar" />
}
